export default "__VITE_ASSET__CaiJ_b9$__"